import { useReveal } from "@/hooks/useReveal";
import { Seo } from "@/components/Seo";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WholesaleHero from "@/pages/wholesale/components/WholesaleHero";
import WhatWeRoast from "@/pages/wholesale/components/WhatWeRoast";
import HowItWorks from "@/pages/wholesale/components/HowItWorks";
import WithTheBeans from "@/pages/wholesale/components/WithTheBeans";
import EnquiryForm from "@/pages/wholesale/components/EnquiryForm";

export default function Wholesale() {
  useReveal();

  return (
    <main className="w-full min-w-[1024px] bg-background-50 text-foreground-950">
      <Seo
        title="Wholesale Coffee for Cafes | Meridian Coffee Roasters"
        description="Wholesale coffee for Portland cafes and trade buyers: a tasting, a house blend for your bar, a standing weekly order, roasted to order and shipped within 48 hours."
        path="/wholesale"
        image="/localized/offering-cafe-01.jpg"
      />
      <Navbar />
      <WholesaleHero />
      <WhatWeRoast />
      <HowItWorks />
      <WithTheBeans />
      <EnquiryForm />
      <Footer />
    </main>
  );
}
